import { ChangeDetectionStrategy, Component, inject, Input } from "@angular/core";
import { Router } from "@angular/router";
import { CustomModal } from "../../../core/components/base-modals";
import { CoreModule } from "../../../core/core.module";
import {
	COOL_OFF_CTA_ACTION,
	COOL_OFF_TRADE_STATUSES,
	CoolOffWidgetModel
} from "@modules/uk-finprom/components/cool-off-widget/entities/cool-off-widget.model";
import { CoolOffWidgetRemote } from "@modules/uk-finprom/components/cool-off-widget/infrastructure/cool-off-widget.remote";

@Component({
	selector: "cooling-off-notification-modal",
	templateUrl: "./cool-off-notification-modal.component.html",
	styleUrls: ["./cool-off-notification-modal.component.scss"],
	standalone: true,
	imports: [CoreModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoolOffNotificationModalComponent extends CustomModal {
	private readonly router = inject(Router);
	private readonly coolOffWidgetRemote = inject(CoolOffWidgetRemote);

	protected readonly COOL_OFF_TRADE_STATUSES = COOL_OFF_TRADE_STATUSES;
	protected readonly COOL_OFF_CTA_ACTION = COOL_OFF_CTA_ACTION;

	@Input() public data: CoolOffWidgetModel;

	public confirm(): void {
		this.coolOffWidgetRemote.postLastCheck$().subscribe();
		super.close();
	}

	public logout(): void {
		this.router.navigate(["/user/logout"]);
	}
}
